import { ApplicationAnswerProps } from './Application';
import { EventProps } from './Event';

export interface AttachmentProps {
  id?: number | null;
  uri?: string | null;
  applicationId?: number | null;
  questionId?: number | null;
  questionText?: string | null;
  description?: string | null;
  eventId?: number | null;
  createdOn?: Date | null;
  fileName?: string | null;
  fileType?: FileType | null;
  questionResponse?: ApplicationAnswerProps | null;
  event?: EventProps | null;
  lythoLink?: string | null;
}

export interface UrlAttachmentProps {
  url?: string | null;
  applicationId?: number | null;
  questionId?: number | null;
  description?: string | null;
  eventId?: number | null;
}

export enum FileType {
  url = 1,
  image = 2,
  video = 3,
  document = 4,
  compressed = 5,
  Unknown = 6,
}

export function fileTypeAsString(userType: FileType): string {
  switch (userType) {
    case FileType.url:
      return 'URL';
    case FileType.image:
      return 'Image';
    case FileType.video:
      return 'Video';
    case FileType.document:
      return 'Document';
    case FileType.compressed:
      return 'Compressed';
    default:
      return 'Unknown';
  }
}

export function fileTypeStringToEnum(userType: string): FileType {
  userType = userType.toLowerCase();

  switch (userType) {
    case 'URL'.toLowerCase():
      return FileType.url;
    case 'Image'.toLowerCase():
      return FileType.image;
    case 'Video'.toLowerCase():
      return FileType.video;
    case 'Document'.toLowerCase():
      return FileType.document;
    case 'Compressed'.toLowerCase():
      return FileType.compressed;
    default:
      return FileType.Unknown;
  }
}

export function isFileFileType(fileType: FileType | string): boolean {
  if (typeof fileType === 'string') {
    fileType = fileTypeStringToEnum(fileType);
  }

  return (
    fileType === FileType.image || fileType === FileType.video || fileType === FileType.document
  );
}
